module.exports = __webpack_public_path__ + "static/media/Chunq.eea95688.ttf";